<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t8' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null &&
              rowData.doc_cte.doc_carga_doc.length > 0
            "
          >
            <span class="nav-link-in">
              Docs
              <i class="fa fa-user"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t24' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.tp_doc.valor == 2"
          >
            <span class="nav-link-in">
              Detalhes RPS
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Partes Env.
              <i class="fa fa-user"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t22' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.tp_doc.valor == 2"
          >
            <span class="nav-link-in">
              Autorizações
              <i class="fa fa-check"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t23' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.tp_doc.valor == 2"
          >
            <span class="nav-link-in">
              Impostos
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null"
          >
            <span class="nav-link-in">
              Impostos
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null"
          >
            <span class="nav-link-in">
              Sefaz
              <i class="fa fa-building"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_aqua"
          >
            <span class="nav-link-in">
              Aquaviário
              <i class="fa fa-ship"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t13' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_aqua"
          >
            <span class="nav-link-in">
              Container
              <i class="fa fa-ship"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_rodo"
          >
            <span class="nav-link-in">
              Rodoviário
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_multi"
          >
            <span class="nav-link-in">
              Multimodal
              <i class="fa fa-share-alt"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t9' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_duto"
          >
            <span class="nav-link-in">
              Dutoviário
              <i class="fa fa-share-alt"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t10' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_ferro"
          >
            <span class="nav-link-in">
              Ferroviário
              <i class="fa fa-train"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t11' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null &&
              rowData.doc_cte.doc_cte_seguro.length > 0
            "
          >
            <span class="nav-link-in">
              Seguro
              <i class="fa fa-lock"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t12' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_comp_frete"
          >
            <span class="nav-link-in">
              Frete
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t13' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_fiscal_adicional"
          >
            <span class="nav-link-in">
              Adicional
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t14' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null &&
              rowData.doc_cte.doc_cte_carga.length > 0
            "
          >
            <span class="nav-link-in">
              Carga
              <i class="fa fa-cubes"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t15' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.carta_correcao != null && rowData.carta_correcao.length > 0"
          >
            <span class="nav-link-in">
              CCE
              <i class="fa fa-envelope-open-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t16' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_adicional"
          >
            <span class="nav-link-in">
              Obs
              <i class="fa fa-commenting-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t17' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null && rowData.doc_cte.doc_cte_complementado
            "
          >
            <span class="nav-link-in">
              CTE Original
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t18' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null &&
              rowData.doc_cte.doc_cte_complementares.length > 0
            "
          >
            <span class="nav-link-in">
              CTES Complementares
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.doc_carga_doc != null && rowData.doc_carga_doc.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t19' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_carga_doc != null &&
              rowData.doc_carga_doc[0].carga_doc.carga_doc_unidade_carga.length > 0
            "
          >
            <span class="nav-link-in">
              Pedido
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t20' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="(rowData.doc_xml_api != null && rowData.doc_xml_api.length > 0) || (rowData.doc_log != null && rowData.doc_log.length > 0)"
          >
            <span class="nav-link-in">
              Integração
              <i class="fa fa-cogs"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t21' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.carga_ocorrencia.length > 0"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t25' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_cte != null &&
              rowData.doc_cte.doc_cte_averbacao.length > 0
            "
          >
            <span class="nav-link-in">
              Averbação
              <i class="fa fa-archive"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t26' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_rps != null &&
              rowData.doc_rps.doc_rps_averbacao.length > 0
            "
          >
            <span class="nav-link-in">
              Averbação
              <i class="fa fa-archive"></i>
            </span>
          </a>
        </li>
                <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t27' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_rps != null &&
              rowData.doc_rps.doc_carga_doc.length > 0
            "
          >
            <span class="nav-link-in">
              Docs
              <i class="fa fa-user"></i>
            </span>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t28' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.doc_rps != null
            "
          >
            <span class="nav-link-in">
              Carga
              <i class="fa fa-cubes"></i>
            </span>
          </a>
        </li> -->
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.doc_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Tipo Documento</th>
                <th style="width: 15%">Municipio Inicio</th>
                <th style="width: 15%">Municipio Fim</th>
                <th style="width: 5%">CFOP</th>
                <th style="width: 5%">NOP</th>
                <th style="width: 30%">Natureza Op.</th>
                <th style="width: 25%">Chave</th>
                <th style="width: 5%">Produto Predominante</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.tp_doc.descr }}
                </td>
                <td>
                  {{ rowData.municipio_inicio.nome }}-{{
                    rowData.municipio_inicio.uf.cd
                  }}
                </td>
                <td>
                  {{ rowData.municipio_fim.nome }}-{{
                    rowData.municipio_fim.uf.cd
                  }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte"
                    >{{ rowData.doc_cte.cfop.cd }}-{{
                      rowData.doc_cte.cfop.descr
                    }}</span
                  >
                </td>
                <td>
                  <span v-if="rowData.nop">{{ rowData.nop }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte != null">{{
                    rowData.doc_cte.natureza_operacao
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte != null">{{
                    rowData.doc_cte.chave
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte != null">{{
                    rowData.doc_cte.doc_cte_adicional.produto_predominante
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.doc_id + ''"
          v-if="rowData.doc_cte_partes_env"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%"></th>
                <th data-toggle="true" style="width: 10%">CNPJ / CPF</th>
                <th data-toggle="true" style="width: 10%">IE</th>
                <th data-toggle="true" style="width: 10%">Nome</th>
                <th data-toggle="true" style="width: 10%">Município</th>
                <th data-toggle="true" style="width: 3%">Estado</th>
                <th data-toggle="true" style="width: 15%">Endereço</th>
                <th data-toggle="true" style="width: 12%">Bairro</th>
                <th data-toggle="true" style="width: 10%">CEP</th>
                <th data-toggle="true" style="width: 10%">Email</th>
                <th data-toggle="true" style="width: 5%">Telefone</th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.emi_endereco"
              >
                <td>
                  <span class="badge badge-primary">Emitente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.emi_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.emi_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.emi_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_endereco }} -
                  {{ rowData.doc_cte_partes_env.emi_complemento }} -
                  {{ rowData.doc_cte_partes_env.emi_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_cep">{{
                    rowData.doc_cte_partes_env.emi_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_email">{{
                    rowData.doc_cte_partes_env.emi_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_telefone">{{
                    rowData.doc_cte_partes_env.emi_telefone
                  }}</span>
                </td>
                <td></td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.rem_endereco"
              >
                <td>
                  <span class="badge badge-warning">Remetente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.rem_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.rem_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.rem_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_endereco }} -
                  {{ rowData.doc_cte_partes_env.rem_complemento }} -
                  {{ rowData.doc_cte_partes_env.rem_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_cep">{{
                    rowData.doc_cte_partes_env.rem_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_email">{{
                    rowData.doc_cte_partes_env.rem_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_telefone">{{
                    rowData.doc_cte_partes_env.rem_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          1
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.exp_endereco"
              >
                <td>
                  <span class="badge badge-info">Expedidor</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.exp_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.exp_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.exp_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_endereco }} -
                  {{ rowData.doc_cte_partes_env.exp_complemento }} -
                  {{ rowData.doc_cte_partes_env.exp_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_cep">{{
                    rowData.doc_cte_partes_env.exp_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_email">{{
                    rowData.doc_cte_partes_env.exp_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_telefone">{{
                    rowData.doc_cte_partes_env.exp_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          3
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.des_endereco"
              >
                <td>
                  <span class="badge badge-success">Destinatário</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.des_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.des_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.des_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_endereco }} -
                  {{ rowData.doc_cte_partes_env.des_complemento }} -
                  {{ rowData.doc_cte_partes_env.des_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_cep">{{
                    rowData.doc_cte_partes_env.des_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_email">{{
                    rowData.doc_cte_partes_env.des_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_telefone">{{
                    rowData.doc_cte_partes_env.des_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          2
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-secondary">Recebedor</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.rec_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.rec_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.rec_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_endereco }} -
                  {{ rowData.doc_cte_partes_env.rec_complemento }} -
                  {{ rowData.doc_cte_partes_env.rec_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_cep">{{
                    rowData.doc_cte_partes_env.rec_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_email">{{
                    rowData.doc_cte_partes_env.rec_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_telefone">{{
                    rowData.doc_cte_partes_env.rec_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          4
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.tom_endereco"
              >
                <td>
                  <span class="badge badge-primary">Tomador</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_cnpj != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.tom_cnpj) }}
                  </span>
                  <span v-if="rowData.doc_cte_partes_env.tom_cpf != null">
                    {{ ajustaMascara(rowData.doc_cte_partes_env.tom_cpf) }}
                  </span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_endereco }} -
                  {{ rowData.doc_cte_partes_env.tom_complemento }} -
                  {{ rowData.doc_cte_partes_env.tom_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_cep">{{
                    rowData.doc_cte_partes_env.tom_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_email">{{
                    rowData.doc_cte_partes_env.tom_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_telefone">{{
                    rowData.doc_cte_partes_env.tom_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          5
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          v-if="rowData.doc_cte != null"
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.doc_id + ''"
        >
          <div v-if="this.isIbsCbsTaxActive">
            <table class="table-striped" id="mais">
              <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">Tipo</th>
                <th data-toggle="true" style="width: 10%">Valor Serviço</th>
                <th data-toggle="true" style="width: 5%">Alíquota</th>
                <th data-toggle="true" style="width: 10%">Total Imposto</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="rowData.doc_imposto_ibs != null" class="bg-gray-light" style="display: table-row">
                <td>
                  IBS
                </td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_ibs.vlr_servico) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_ibs.aliquota) + "%" }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_ibs.valor) }}
                </td>
              </tr>
              <tr v-else class="bg-gray-light" style="display: table-row">
                <td>IBS</td>
                <td>-</td>
                <td>-</td>
                <td>Não aplicável</td>
              </tr>
              </tbody>
            </table>
            <table class="table-striped" id="mais">
              <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">Tipo</th>
                <th data-toggle="true" style="width: 10%">Valor Serviço</th>
                <th data-toggle="true" style="width: 5%">Alíquota</th>
                <th data-toggle="true" style="width: 10%">Total Imposto</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="rowData.doc_imposto_cbs != null" class="bg-gray-light" style="display: table-row">
                <td>CBS</td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_cbs.vlr_servico) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_cbs.aliquota) + "%" }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_imposto_cbs.valor) }}
                </td>
              </tr>
              <tr v-else class="bg-gray-light" style="display: table-row">
                <td>CBS</td>
                <td>-</td>
                <td>-</td>
                <td>Não aplicável</td>
              </tr>
              </tbody>
            </table>
          </div>
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th data-toggle="true" style="width: 5%">Tipo</th>
              <th data-toggle="true" style="width: 5%">CST</th>
              <th data-toggle="true" style="width: 10%">Vlr Base Cálculo</th>
              <th data-toggle="true" style="width: 5%">Alíquota</th>
              <th data-toggle="true" style="width: 10%">ICMS</th>
              <th data-toggle="true" style="width: 10%">% Redução BC</th>
              <th data-toggle="true" style="width: 10%">
                Vlr BC ICMS ST Retido
              </th>
              <th data-toggle="true" style="width: 10%">
                Vlr ICMS ST Retido
              </th>
              <th data-toggle="true" style="width: 10%">
                Vlr Crédito Presumido
              </th>
              <th data-toggle="true" style="width: 10%">Simples</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bg-gray-light" style="display: table-row">
              <td>ICMS</td>
              <td>
                {{ rowData.doc_cte.doc_cte_imposto.cst }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.vlr_base_calculo
                  )
                }}
              </td>
              <td>
                {{
                  formatNumber(rowData.doc_cte.doc_cte_imposto.aliquota_icms)
                }}
              </td>
              <td>
                {{ formatNumber(rowData.doc_cte.doc_cte_imposto.vlr_icms) }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.percentual_reducao_bc
                  )
                }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.vlr_bc_icms_st_retido
                  )
                }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.vlr_icms_st_retido
                  )
                }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.vlr_credito_presumido
                  )
                }}
              </td>
              <td>
                {{
                  formatNumber(
                      rowData.doc_cte.doc_cte_imposto.indicador_simples_nacional
                  )
                }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          v-if="rowData.doc_cte != null"
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + rowData.doc_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">Status Sefaz</th>
                <th data-toggle="true" style="width: 5%">Status Mensageria</th>
                <th
                  v-if="rowData.doc_cte.sefaz_validador_wsdl !== null"
                  data-toggle="true"
                  style="width: 30%"
                >
                  Erro WSDL
                </th>
                <th
                  v-if="rowData.doc_cte.sefaz_motivo !== null"
                  data-toggle="true"
                  style="width: 30%"
                >
                  Descrição
                </th>
                <th
                  v-if="rowData.doc_cte.sefaz_digestval !== null"
                  data-toggle="true"
                  style="width: 30%"
                >
                  DigestVal
                </th>
                <th
                  v-if="rowData.doc_cte.sefaz_protocolo !== null"
                  data-toggle="true"
                  style="width: 20%"
                >
                  Protocolo
                </th>
                <th
                  v-if="rowData.doc_cte.sefaz_dh_recebto !== null"
                  data-toggle="true"
                  style="width: 10%"
                >
                  Data/hora Recebimento
                </th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_cte.status_sefaz.descr }}
                </td>
                <td>
                  <span
                    class="badge badge-warning"
                    v-if="rowData.doc_cte.status_mensageria.valor == 1"
                    >{{ rowData.doc_cte.status_mensageria.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="rowData.doc_cte.status_mensageria.valor == 2"
                    >{{ rowData.doc_cte.status_mensageria.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="rowData.doc_cte.status_mensageria.valor == 3"
                    >{{ rowData.doc_cte.status_mensageria.descr }}</span
                  >
                </td>
                <td v-if="rowData.doc_cte.sefaz_validador_wsdl !== null">
                  {{ rowData.doc_cte.sefaz_validador_wsdl }}
                </td>
                <td v-if="rowData.doc_cte.sefaz_motivo !== null">
                  {{ rowData.doc_cte.sefaz_motivo }}
                </td>
                <td v-if="rowData.doc_cte.sefaz_digestval !== null">
                  {{ rowData.doc_cte.sefaz_digestval }}
                </td>
                <td v-if="rowData.doc_cte.sefaz_protocolo !== null">
                  {{ rowData.doc_cte.sefaz_protocolo }}
                </td>
                <td v-if="rowData.doc_cte.sefaz_dh_recebto !== null">
                  {{ formatDate(rowData.doc_cte.sefaz_dh_recebto) }}
                </td>
                <td>
                  <span v-if="getPermission('cte.imprimir')">
                    <span v-if="rowData.doc_cte.status_sefaz.valor == 4">
                      <a
                        @click="
                          onCreateEnviarXmlDacte(rowData.doc_cte.doccte_id)
                        "
                        v-if="rowData.doc_cte.doc_cte_xml.length > 0"
                        v-b-tooltip
                        title="Enviar CTE"
                        ><i class="fa fa-send"></i
                      ></a>
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
            <thead
              v-if="
                rowData.doc_cte != null && rowData.doc_cte.sefaz_status_canc
              "
            >
              <tr>
                <th data-toggle="true" style="width: 20%">Hora Cancelamento</th>
                <th data-toggle="true" style="width: 20%">Descrição</th>
                <th data-toggle="true" style="width: 10%">Status</th>
                <th data-toggle="true" style="width: 10%">Motivo</th>
                <th data-toggle="true" style="width: 20%">Data/hora Envio</th>
                <th data-toggle="true" style="width: 20%">
                  Data/hora Recebimento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte.sefaz_status_canc"
              >
                <td>
                  {{ rowData.doc_cte.sefaz_dhrecbto_canc }}
                </td>
                <td>
                  {{ rowData.doc_cte.sefaz_nprot_canc }}
                </td>
                <td>
                  {{ rowData.doc_cte.sefaz_status_canc }}
                </td>
                <td>
                  {{ rowData.doc_cte.sefaz_xmotivo_canc }}
                </td>
                <td>
                  {{ formatDate(rowData.doc_cte.sefaz_dt_envio_canc) }}
                </td>
                <td>
                  {{ formatDate(rowData.doc_cte.sefaz_dt_recbto_canc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_aqua"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">
                  Valor Base de Calculo AFRMM
                </th>
                <th data-toggle="true" style="width: 10%">Valor AFRMM</th>
                <th data-toggle="true" style="width: 10%">Número do Booking</th>
                <th data-toggle="true" style="width: 10%">Navio</th>
                <th data-toggle="true" style="width: 15%">
                  Número Viagem / Direção
                </th>
                <th data-toggle="true" style="width: 15%">Porto Embarque</th>
                <th data-toggle="true" style="width: 10%">Porto Transbordo</th>
                <th data-toggle="true" style="width: 10%">Porto Desembarque</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{
                    formatNumber(
                      rowData.doc_cte.doc_cte_aqua.vlr_base_calculo_afrmm
                    )
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_cte.doc_cte_aqua.vlr_afrmm) }}
                </td>
                <td>
                  {{ rowData.doc_cte.doc_cte_aqua.num_booking }}
                </td>
                <td>
                  {{ rowData.doc_cte.doc_cte_aqua.embarcacao.nome }}
                </td>
                <td>
                  {{ rowData.doc_cte.doc_cte_aqua.num_viagem }} -
                  {{ rowData.doc_cte.doc_cte_aqua.direcao }}
                </td>
                <td>
                  {{ rowData.doc_cte.doc_cte_aqua.porto_embarque.cd }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte.doc_cte_aqua.porto_transbordo">{{
                    rowData.doc_cte.doc_cte_aqua.porto_transbordo.cd
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte.doc_cte_aqua.porto_destino.cd }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_rodo"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">RNTRC</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{ rowData.doc_cte.doc_cte_rodo.rntrc }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_multi"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">COTM</th>
                <th data-toggle="true" style="width: 10%">Negociável</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{ rowData.doc_cte.doc_cte_multi.num_cotm }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_multi.ind_negociavel
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null && rowData.doc_cte.doc_carga_doc.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">Tipo</th>
                <th data-toggle="true" style="width: 20%">Chave</th>
                <th data-toggle="true" style="width: 10%">Número Fiscal</th>
                <th data-toggle="true" style="width: 10%">Série</th>
                <th data-toggle="true" style="width: 10%">Data de Emissão</th>
                <th data-toggle="true" style="width: 10%">CNPJ</th>
                <th data-toggle="true" style="width: 20%">Razão Social</th>
                <th data-toggle="true" style="width: 10%">Inscrição Estadual</th>
                <th data-toggle="true" style="width: 10%">Qtde Reentrega</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_carga_doc"
              >
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ item.carga_doc.doc_fiscal.liv_tp_doc.descr }}
                  </span>
                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{ item.carga_doc.doc_transp.liv_tp_doc.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    <span v-if="item.carga_doc.doc_fiscal.chave">
                      {{ item.carga_doc.doc_fiscal.chave }}
                    </span>
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    <span v-if="item.carga_doc.doc_transp.chave">
                      {{ item.carga_doc.doc_transp.chave }}
                    </span>
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="item.carga_doc.doc_fiscal"
                  >
                    {{ item.carga_doc.doc_fiscal.num_fiscal }}
                  </span>

                  <span
                    class="badge badge-danger"
                    v-if="item.carga_doc.doc_transp !== null"
                  >
                    {{ item.carga_doc.doc_transp.num_doc }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ item.carga_doc.doc_fiscal.serie }}
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{ item.carga_doc.doc_transp.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ formatDate(item.carga_doc.doc_fiscal.dt_emissao) }}
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{ formatDate(item.carga_doc.doc_transp.dt_emissao) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_cnpj
                    }}
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_cnpj
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_nome
                    }}
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_nome
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_cnpj
                    }}
                  </span>

                  <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_cnpj
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal.qtde_reentrega">
                    {{
                      item.carga_doc.doc_fiscal.qtde_reentrega
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_duto"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 40%">Valor Tarifa</th>
                <th data-toggle="true" style="width: 30%">Início</th>
                <th data-toggle="true" style="width: 30%">Fim</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{
                    formatNumber(rowData.doc_cte.doc_cte_duto.vlr_tarifa)
                  }}</span>
                </td>
                <td>
                  <span>{{
                    formatDate(rowData.doc_cte.doc_cte_duto.dt_inicio)
                  }}</span>
                </td>
                <td>
                  <span>{{
                    formatDate(rowData.doc_cte.doc_cte_duto.dt_fim)
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t10' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null && rowData.doc_cte.doc_cte_ferro !== null
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Fluxo</th>
                <th data-toggle="true" style="width: 10%">Identificação</th>
                <th data-toggle="true" style="width: 20%">Valor Frete</th>
                <th data-toggle="true" style="width: 20%">Ferrovia Emitente</th>
                <th data-toggle="true" style="width: 20%">
                  Faturamento Ferrovia
                </th>
                <th data-toggle="true" style="width: 20%">Tráfego</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_ferro.fluxo_ferroviario
                  }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_cte.doc_cte_ferro.ident_trem }}</span>
                </td>
                <td>
                  <span>{{
                    formatNumber(rowData.doc_cte.doc_cte_ferro.vlr_frete)
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_ferro.param_ferrovia_emitente.descr
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_ferro.param_resp_fat_ferro.descr
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_ferro.param_tipo_trafego_ferro.descr
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t11' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null && rowData.doc_cte.doc_cte_seguro.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 30%">Seguradora</th>
                <th data-toggle="true" style="width: 30%">Apólice</th>
                <th data-toggle="true" style="width: 40%">
                  Seguradora Responsável
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_cte_seguro"
              >
                <td>
                  <span>{{ item.seguradora.nome }}</span>
                </td>
                <td>
                  <span>{{ item.seguradora.apolice }}</span>
                </td>
                <td>
                  <span>{{ item.param_tipo_resp_seg.descr }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t12' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_comp_frete"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 30%">Nome</th>
                <th data-toggle="true" style="width: 30%">Valor</th>
                <th data-toggle="true" style="width: 40%">Custo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_cte_comp_frete"
              >
                <td>
                  <span>{{ item.nome }}</span>
                </td>
                <td>
                  <span>{{ formatNumber(item.vlr) }}</span>
                </td>
                <td>
                  <span>{{ item.custo.descr }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t13' + rowData.doc_id + ''"
          v-if="rowData.doc_cte != null && rowData.doc_cte.doc_cte_aqua"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th
                  v-if="
                    rowData.doc_cte.doc_cte_aqua.doc_cte_aqua_container !== null
                  "
                  data-toggle="true"
                  style="width: 50%"
                >
                  Número Container
                </th>
                <th
                  v-if="
                    rowData.doc_cte.doc_cte_aqua.doc_cte_aqua_container
                      .doc_cte_aqua_container_lacre !== null
                  "
                  data-toggle="true"
                  style="width: 50%"
                >
                  Número Lacre
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_cte_aqua
                  .doc_cte_aqua_container"
              >
                <td v-if="item.num_container !== null">
                  <span>{{ item.num_container }}</span>
                </td>
                <td v-if="item.doc_cte_aqua_container_lacre.num_lacre !== null">
                  <span>{{ item.doc_cte_aqua_container_lacre.num_lacre }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t14' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null && rowData.doc_cte.doc_cte_carga.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 40%">Unidade Medida</th>
                <th data-toggle="true" style="width: 40%">Tipo Medida</th>
                <th data-toggle="true" style="width: 20%">Quantidade</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_cte_carga"
              >
                <td>
                  <span>{{ item.param_unidade_medida.descr }}</span>
                </td>
                <td>
                  <span>{{ item.param_tipo_medida.descr }}</span>
                </td>
                <td>
                  <span>{{ formatNumber(item.qtd) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t15' + rowData.doc_id + ''"
          v-if="rowData.carta_correcao.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">N° Fiscal</th>
                <th data-toggle="true" style="width: 5%">Sequência</th>
                <th data-toggle="true" style="width: 10%">Observação</th>
                <th data-toggle="true" style="width: 5%">Tipo Carta</th>
                <th data-toggle="true" style="width: 5%">Status</th>
                <th
                  v-if="rowData.carta_correcao.sefaz_protocolo !== null"
                  data-toggle="true"
                  style="width: 10%"
                >
                  Protocolo Sefaz
                </th>
                <th
                  v-if="rowData.carta_correcao.sefaz_status_descr !== null"
                  data-toggle="true"
                  style="width: 15%"
                >
                  Status Sefaz
                </th>
                <th
                  v-if="rowData.carta_correcao.sefaz_tp_evento_descr !== null"
                  data-toggle="true"
                  style="width: 15%"
                >
                  Evento Sefaz
                </th>
                <th
                  v-if="rowData.carta_correcao.sefaz_orgao !== null"
                  data-toggle="true"
                  style="width: 5%"
                >
                  Orgão Sefaz
                </th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carta_correcao"
              >
                <td>
                  <span>{{ item.num_fiscal }}</span>
                </td>
                <td>
                  <span>{{ item.num_seq }}</span>
                </td>
                <td>
                  <span>{{ item.obs }}</span>
                </td>
                <td>
                  <span>{{ item.tp_carta }}</span>
                </td>
                <td>
                  <span>{{ item.status.descr }}</span>
                </td>
                <td v-if="rowData.carta_correcao.sefaz_protocolo !== null">
                  <span>{{ item.sefaz_protocolo }}</span>
                </td>
                <td v-if="rowData.carta_correcao.sefaz_status_descr !== null">
                  <span>{{ item.sefaz_status_descr }}</span>
                </td>
                <td
                  v-if="rowData.carta_correcao.sefaz_tp_evento_descr !== null"
                >
                  <span>{{ item.sefaz_tp_evento_descr }}</span>
                </td>
                <td v-if="rowData.carta_correcao.sefaz_orgao !== null">
                  <span>{{ item.sefaz_orgao }}</span>
                </td>
                <td>
                  <span v-if="item.status.valor == 4">
                    <a
                      @click="onPrintCarta(item.carcor_id)"
                      v-b-tooltip
                      title="Imprimir Carta de Correção"
                      ><i class="fa fa-print"></i
                    ></a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.carta_correcao[0].carta_correcao_item.length > 0"
          >
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Grupo</th>
                <th data-toggle="true" style="width: 10%">TAG</th>
                <th data-toggle="true" style="width: 30%">Valor Anterior</th>
                <th data-toggle="true" style="width: 30%">Valor Novo</th>
                <th data-toggle="true" style="width: 10%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carta_correcao[0].carta_correcao_item"
              >
                <td>
                  <span>{{ item.grupo }}</span>
                </td>
                <td>
                  <span>{{ item.tag }}</span>
                </td>
                <td>
                  <span>{{ item.vlr_anterior }}</span>
                </td>
                <td>
                  <span>{{ item.vlr_novo }}</span>
                </td>
                <td>
                  <span>{{ item.status.descr }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t16' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null &&
            rowData.doc_cte.doc_cte_adicional.observacao_geral
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 30%">Observação Geral</th>
                <th data-toggle="true" style="width: 20%">Observação Fisco</th>
                <th data-toggle="true" style="width: 20%">Motivo do Cancelamento</th>
                <th data-toggle="true" style="width: 20%">Descr. Cancelamento</th>
                <th data-toggle="true" style="width: 10%">Dt.Cancelamento</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span
                    v-if="rowData.doc_cte.doc_cte_adicional.observacao_geral"
                    >{{
                      rowData.doc_cte.doc_cte_adicional.observacao_geral
                    }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="rowData.doc_cte.doc_cte_adicional.observacao_fisco"
                    >{{
                      rowData.doc_cte.doc_cte_adicional.observacao_fisco
                    }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="rowData.param_motivo != null"
                    >{{
                      rowData.param_motivo.descr
                    }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="rowData.descr_cancelamento != null"
                    >{{
                      rowData.descr_cancelamento
                    }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="rowData.dt_cancelamento != null"
                    >{{
                      formatDate(rowData.dt_cancelamento)
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t17' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null &&
            rowData.doc_cte.doc_cte_complementado !== null
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">N° Fiscal</th>
                <th data-toggle="true" style="width: 10%">Modal</th>
                <th data-toggle="true" style="width: 10%">Série</th>
                <th data-toggle="true" style="width: 20%">Data Emissão</th>
                <th data-toggle="true" style="width: 40%">Chave CTE</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_complementado.doc.num_fiscal
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_complementado.doc.b_modal.descr
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_cte.doc_cte_complementado.doc.serie
                  }}</span>
                </td>
                <td>
                  <span>{{
                    formatDate(rowData.doc_cte.doc_cte_complementado.doc.dt_emi)
                  }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_cte.doc_cte_complementado.chave }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t18' + rowData.doc_id + ''"
          v-if="
            rowData.doc_cte != null &&
            rowData.doc_cte.doc_cte_complementares.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">N° Fiscal</th>
                <th data-toggle="true" style="width: 20%">N° Controle</th>
                <th data-toggle="true" style="width: 20%">Modal</th>
                <th data-toggle="true" style="width: 20%">Data Emissão</th>
                <th data-toggle="true" style="width: 20%">CFOP</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_cte.doc_cte_complementares"
              >
                <td>
                  <span>{{ item.doc.num_fiscal }}</span>
                </td>
                <td>
                  <span>{{ item.doc.num_controle }}</span>
                </td>
                <td>
                  <span>{{ item.doc.b_modal.descr }}</span>
                </td>
                <td>
                  <span>{{ formatDate(item.doc.dt_emi) }}</span>
                </td>
                <td>
                  <span>{{ item.cfop.descr }}-{{ item.cfop.valor }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t19' + rowData.doc_id + ''"
          v-if="
            rowData.doc_carga_doc != null &&
            rowData.doc_carga_doc.length > 0 &&
            rowData.doc_carga_doc[0].carga_doc.carga_doc_unidade_carga.length >
              0
          "
        >
          <div class="tabs-section-nav">
            <div class="tbl">
              <ul class="nav" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    v-bind:href="'#st1' + rowData.doc_id + ''"
                    v-if="
                      rowData.doc_carga_doc != null &&
                      rowData.doc_carga_doc[0].carga_doc
                        .carga_doc_unidade_carga[0].pedido_unidade_carga
                        .pedido != null
                    "
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-road"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:href="'#st2' + rowData.doc_id + ''"
                    v-if="
                      rowData.doc_carga_doc != null &&
                      rowData.doc_carga_doc[0].carga_doc
                        .carga_doc_unidade_carga[0].pedido_unidade_carga
                        .pedido != null
                    "
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="nav-link-in">
                      Trecho
                      <i class="fa fa-road"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:href="'#st3' + rowData.doc_id + ''"
                    v-if="
                      rowData.doc_carga_doc != null &&
                      rowData.doc_carga_doc[0].carga_doc
                        .carga_doc_unidade_carga[0].pedido_unidade_carga
                        .pedido != null
                    "
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="nav-link-in">
                      Componente de Frete
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:href="'#st4' + rowData.doc_id + ''"
                    v-if="
                      rowData.doc_carga_doc != null &&
                      rowData.doc_carga_doc[0].carga_doc
                        .carga_doc_unidade_carga[0].pedido_unidade_carga
                        .pedido != null
                    "
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="nav-link-in">
                      Detalhe da Unidade de Carga
                      <i class="fa fa-ship"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="tab-content">
            <div
              role="tabpanel"
              class="
                tab-pane
                fade
                in
                active
                show
                pt-1
                border-color-detalhes-grey
              "
              v-bind:id="'st1' + rowData.doc_id + ''"
            >
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th style="width: 15%">CFOP</th>
                    <th style="width: 15%">CST</th>
                    <th style="width: 15%">Municipio de Início</th>
                    <th style="width: 15%">Municipio de Fim</th>
                    <th style="width: 10%">Tipo Pedido</th>
                    <th style="width: 10%">Tipo Serviço</th>
                    <th style="width: 10%">Tipo Carga</th>
                    <th style="width: 10%">Tipo Fronteira</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      <span
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.cfop != null
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.cfop.descr
                        }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.param_cst != null
                        "
                      >
                        {{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.param_cst.cd
                        }}
                        -
                        {{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.param_cst.descr
                        }}
                      </span>
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.municipio_inicio.nome
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.municipio_fim.nome
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.tp_pedido.descr
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.tp_servico.descr
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.tp_carga.descr
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.tp_fronteira.descr
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th style="width: 20%">Produto Predominante</th>
                    <th style="width: 20%">Tomador CTE</th>
                    <th style="width: 20%">Modal</th>
                    <th style="width: 20%">Observação</th>
                    <th style="width: 5%">Exibe ADValorem CFrete</th>
                    <th style="width: 5%">Permite Adicionar UC</th>
                    <th style="width: 5%">Imposto Incluso</th>
                    <th style="width: 5%">% ADValorem</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.produto_predominante
                      }}
                    </td>
                    <td>
                      <span
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.pedido_tomador.descr
                        "
                      >
                        {{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.pedido_tomador.descr
                        }}
                      </span>
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.b_modal.descr
                      }}
                    </td>
                    <td>
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs
                      }}
                    </td>
                    <td>
                      <span
                        class="badge badge-success"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.exibe_advalorem_c_frete.valor == 1
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.exibe_advalorem_c_frete.descr
                        }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.exibe_advalorem_c_frete.valor == 2
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.exibe_advalorem_c_frete.descr
                        }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="badge badge-success"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.permite_adicionar_uc.valor == 1
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.permite_adicionar_uc.descr
                        }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.permite_adicionar_uc.valor == 2
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.permite_adicionar_uc.descr
                        }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="badge badge-success"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.imposto_incluso.valor == 1
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.imposto_incluso.descr
                        }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.imposto_incluso.valor == 2
                        "
                        >{{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.imposto_incluso.descr
                        }}</span
                      >
                    </td>
                    <td>
                      <span v-if="
                          rowData.doc_carga_doc != null &&
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedido.imposto_incluso.valor == 2
                        ">
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.percentual_advalorem
                      }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th
                      v-if="
                        rowData.doc_carga_doc != null &&
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte != null
                      "
                      style="width: 50%"
                    >
                      Observação CTE
                    </th>
                    <th
                      v-if="
                        rowData.doc_carga_doc != null &&
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte_fiscal != null
                      "
                      style="width: 50%"
                    >
                      Observação CTE Fiscal
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td
                      v-if="
                        rowData.doc_carga_doc != null &&
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte != null
                      "
                    >
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte
                      }}
                    </td>
                    <td
                      v-if="
                        rowData.doc_carga_doc != null &&
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte_fiscal != null
                      "
                    >
                      {{
                        rowData.doc_carga_doc[0].carga_doc
                          .carga_doc_unidade_carga[0].pedido_unidade_carga
                          .pedido.obs_cte_fiscal
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              role="tabpanel"
              class="tab-pane fade pt-1 border-color-detalhes-grey"
              v-bind:id="'st2' + rowData.doc_id + ''"
              v-if="rowData.doc_carga_doc != null"
            >
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th style="width: 5%">Ordem/Principal</th>
                    <th style="width: 10%">Tipo Trecho</th>
                    <th style="width: 15%">Tipo Custo</th>
                    <th style="width: 15%">Modal</th>
                    <th style="width: 13%">Município Início</th>
                    <th style="width: 12%">Municipio Fim</th>
                    <th style="width: 15%">Fornecedor</th>
                    <th style="width: 5%">Status</th>
                    <th style="width: 5%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="item in rowData.doc_carga_doc[0].carga_doc
                      .carga_doc_unidade_carga[0].pedido_unidade_carga.pedido
                      .pedido_param_trecho"
                  >
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        {{ item.ordem }} -
                        <span
                          class="badge badge-success"
                          v-if="item.principal.valor == 1"
                          >{{ item.principal.descr }}</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="item.principal.valor == 2"
                          >{{ item.principal.descr }}</span
                        >
                      </td>
                      <td>
                        {{ item.tp_trecho.descr }}
                      </td>
                      <td>
                        <span
                          class="badge badge-success"
                          v-if="item.tp_custo.valor == 1"
                          >{{ item.tp_custo.descr }}</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="item.tp_custo.valor == 2"
                          >{{ item.tp_custo.descr }}</span
                        >
                      </td>
                      <td>
                        {{ item.b_modal.descr }}
                      </td>
                      <td>
                        {{ item.municipio_inicio.nome }}
                      </td>
                      <td>
                        {{ item.municipio_fim.nome }}
                      </td>
                      <td>
                        <span
                          v-if="
                            item.fornecedor !== null &&
                            item.fornecedor.pessoa_juridica !== null
                          "
                          >{{
                            onFormataCnpj(
                              item.fornecedor.pessoa_juridica.cnpj_base,
                              item.fornecedor.pessoa_juridica.cnpj_filial,
                              item.fornecedor.pessoa_juridica.cnpj_digito
                            )
                          }}
                          -
                          {{
                            item.fornecedor.pessoa_juridica.razao_social
                          }}</span
                        >
                        <span
                          v-if="
                            item.fornecedor !== null &&
                            item.fornecedor.pessoa_fisica !== null
                          "
                          >{{ item.fornecedor.pessoa_fisica.nome }} -
                          {{ item.fornecedor.pessoa_fisica.cpf }}</span
                        >
                        <span
                          v-if="
                            item.fornecedor !== null &&
                            item.fornecedor.pessoa_exterior !== null
                          "
                          >{{ item.fornecedor.pessoa_exterior.nome }} -
                          {{ item.fornecedor.pessoa_exterior.cuit }}</span
                        >
                      </td>
                      <td>
                        <span
                          class="badge badge-success"
                          v-if="item.status.valor == 1"
                          >{{ item.status.descr }}</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="item.status.valor == 2"
                          >{{ item.status.descr }}</span
                        >
                      </td>
                      <td>
                        <a
                          @click="onDetailTrecho(item)"
                          v-if="item.pedido_param_trecho_custo.length > 0"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </td>
                    </tr>
                    <tr v-if="isVisibleDetailRow(item.pedpartrc_id)">
                      <td colspan="9">
                        <section class="tabs-section">
                          <div class="tabs-section-nav">
                            <div class="tbl">
                              <ul class="nav" role="tablist">
                                <li class="nav-item">
                                  <a
                                    class="nav-link active"
                                    v-bind:href="'#t1' + item.pedpartrc_id + ''"
                                    role="tab"
                                    data-toggle="tab"
                                  >
                                    <span class="nav-link-in">
                                      Custos do Trecho
                                      <i class="fa fa-bulding"></i>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!--.tabs-section-nav-->
                          <div class="tab-content">
                            <div
                              role="tabpanel"
                              class="
                                tab-pane
                                fade
                                in
                                active
                                show
                                pt-1
                                border-color-detalhes-grey
                              "
                              v-bind:id="'t1' + item.pedpartrc_id + ''"
                            >
                              <table
                                :class="[
                                  'vuetable table table-striped tbl-typical',
                                ]"
                              >
                                <thead>
                                  <tr>
                                    <th style="width: 20%">Descrição</th>
                                    <th style="width: 20%">Tipo Custo</th>
                                    <th style="width: 20%">Custo</th>
                                    <th style="width: 20%">Valor</th>
                                    <th style="width: 20%">Status</th>
                                  </tr>
                                </thead>
                                <tbody
                                  v-for="item_trecho_custo in item.pedido_param_trecho_custo"
                                >
                                  <tr
                                    class="bg-gray-light"
                                    style="display: table-row"
                                  >
                                    <td>
                                      <span
                                        v-if="item_trecho_custo.descr !== null"
                                        >{{ item_trecho_custo.descr }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        v-if="
                                          item_trecho_custo.tp_custo.descr !==
                                          null
                                        "
                                        >{{
                                          item_trecho_custo.tp_custo.descr
                                        }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        v-if="
                                          item_trecho_custo.custo.descr !== null
                                        "
                                        >{{
                                          item_trecho_custo.custo.descr
                                        }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        v-if="
                                          item_trecho_custo.vlr_custo !== null
                                        "
                                        >{{ item_trecho_custo.vlr_custo }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        class="badge badge-success"
                                        v-if="
                                          item_trecho_custo.status.valor == 1
                                        "
                                        >{{
                                          item_trecho_custo.status.descr
                                        }}</span
                                      >
                                      <span
                                        class="badge badge-danger"
                                        v-if="
                                          item_trecho_custo.status.valor == 2
                                        "
                                        >{{
                                          item_trecho_custo.status.descr
                                        }}</span
                                      >
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </section>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div
              role="tabpanel"
              class="tab-pane fade pt-1 border-color-detalhes-grey"
              v-bind:id="'st3' + rowData.doc_id + ''"
              v-if="rowData.doc_carga_doc != null"
            >
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th style="width: 50%">Custo</th>
                    <th style="width: 30%">Insere Advalorem</th>
                    <th style="width: 20%">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="bg-gray-light"
                    style="display: table-row"
                    v-for="item in rowData.doc_carga_doc[0].carga_doc
                      .carga_doc_unidade_carga[0].pedido_unidade_carga.pedido
                      .pedido_param_comp_frete"
                  >
                    <td>
                      {{ item.custo.descr }}
                    </td>
                    <td>
                      <span
                        class="badge badge-success"
                        v-if="item.insere_advalorem.valor == 1"
                        >{{ item.insere_advalorem.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="item.insere_advalorem.valor == 2"
                        >{{ item.insere_advalorem.descr }}</span
                      >
                    </td>
                    <td>
                      {{ item.vlr }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              role="tabpanel"
              class="tab-pane fade pt-1 border-color-detalhes-grey"
              v-bind:id="'st4' + rowData.doc_id + ''"
              v-if="rowData.doc_carga_doc != null"
            >
              <table class="table-striped" id="mais">
                <thead>
                  <tr>
                    <th style="width: 70%">N° UC</th>
                    <th style="width: 20%">Status</th>
                    <th style="width: 10%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        {{
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .num_uc
                        }}
                      </td>
                      <td>
                        <span
                          class="badge badge-primary"
                          v-if="
                            rowData.doc_carga_doc != null &&
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.valor == 1
                          "
                          >{{
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.descr
                          }}</span
                        >
                        <span
                          class="badge badge-warning"
                          v-if="
                            rowData.doc_carga_doc != null &&
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.valor == 2
                          "
                          >{{
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.descr
                          }}</span
                        >
                        <span
                          class="badge badge-success"
                          v-if="
                            rowData.doc_carga_doc != null &&
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.valor == 3
                          "
                          >{{
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.descr
                          }}</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="
                            rowData.doc_carga_doc != null &&
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.valor == 4
                          "
                          >{{
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .status.descr
                          }}</span
                        >
                      </td>
                      <td>
                        <a
                          @click="
                            onDetailUnidadeCargaTrecho(
                              rowData.doc_carga_doc[0].carga_doc
                                .carga_doc_unidade_carga[0].pedido_unidade_carga
                                .pedunicar_id
                            )
                          "
                          v-if="
                            rowData.doc_carga_doc != null &&
                            rowData.doc_carga_doc[0].carga_doc
                              .carga_doc_unidade_carga[0].pedido_unidade_carga
                              .pedido_unidade_carga_trecho.length > 0
                          "
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        isVisibleDetailRowPedido(
                          rowData.doc_carga_doc[0].carga_doc
                            .carga_doc_unidade_carga[0].pedido_unidade_carga
                            .pedunicar_id
                        )
                      "
                    >
                      <td colspan="9">
                        <section class="tabs-section">
                          <div class="tabs-section-nav">
                            <div class="tbl">
                              <ul class="nav" role="tablist">
                                <li class="nav-item">
                                  <a
                                    class="nav-link active"
                                    v-bind:href="
                                      '#t2' +
                                      rowData.doc_carga_doc[0].carga_doc
                                        .carga_doc_unidade_carga[0]
                                        .pedido_unidade_carga.pedunicar_id +
                                      ''
                                    "
                                    role="tab"
                                    data-toggle="tab"
                                  >
                                    <span class="nav-link-in">
                                      Trechos
                                      <i class="fa fa-bulding"></i>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!--.tabs-section-nav-->
                          <div class="tab-content">
                            <div
                              role="tabpanel"
                              class="
                                tab-pane
                                fade
                                in
                                active
                                show
                                pt-1
                                border-color-detalhes-grey
                              "
                              v-bind:id="
                                't2' +
                                rowData.doc_carga_doc[0].carga_doc
                                  .carga_doc_unidade_carga[0]
                                  .pedido_unidade_carga.pedunicar_id +
                                ''
                              "
                            >
                              <table
                                :class="[
                                  'vuetable table table-striped tbl-typical',
                                ]"
                              >
                                <thead>
                                  <tr>
                                    <th style="width: 10%">Nº Trecho</th>
                                    <th style="width: 5%">Ordem/Principal</th>
                                    <th style="width: 5%">Tipo Trecho</th>
                                    <th style="width: 10%">Tipo Custo</th>
                                    <th style="width: 15%">Modal</th>
                                    <th style="width: 13%">Município Início</th>
                                    <th style="width: 12%">Municipio Fim</th>
                                    <th style="width: 15%">Fornecedor</th>
                                    <th style="width: 5%">Status</th>
                                    <th style="width: 5%">Ações</th>
                                  </tr>
                                </thead>
                                <tbody
                                  v-for="item_trecho in rowData.doc_carga_doc[0]
                                    .carga_doc.carga_doc_unidade_carga[0]
                                    .pedido_unidade_carga
                                    .pedido_unidade_carga_trecho"
                                >
                                  <tr
                                    class="bg-gray-light"
                                    style="display: table-row"
                                  >
                                    <td>
                                      <span
                                        v-if="item_trecho.num_trecho !== null"
                                        >{{ item_trecho.num_trecho }}</span
                                      >
                                    </td>
                                    <td>
                                      <span v-if="item_trecho.ordem !== null">{{
                                        item_trecho.ordem
                                      }}</span>
                                      -
                                      <span
                                        class="badge badge-success"
                                        v-if="item_trecho.principal.valor == 1"
                                        >{{ item_trecho.principal.descr }}</span
                                      >
                                      <span
                                        class="badge badge-danger"
                                        v-if="item_trecho.principal.valor == 2"
                                        >{{ item_trecho.principal.descr }}</span
                                      >
                                    </td>
                                    <td>
                                      {{ item_trecho.tp_trecho.descr }}
                                    </td>
                                    <td>
                                      <span
                                        class="badge badge-success"
                                        v-if="item_trecho.tp_custo.valor == 1"
                                        >{{ item_trecho.tp_custo.descr }}</span
                                      >
                                      <span
                                        class="badge badge-danger"
                                        v-if="item_trecho.tp_custo.valor == 2"
                                        >{{ item_trecho.tp_custo.descr }}</span
                                      >
                                    </td>
                                    <td>
                                      {{ item_trecho.b_modal.descr }}
                                    </td>
                                    <td>
                                      {{ item_trecho.municipio_inicio.nome }}
                                    </td>
                                    <td>
                                      {{ item_trecho.municipio_fim.nome }}
                                    </td>
                                    <td>
                                      <span
                                        v-if="
                                          item_trecho.fornecedor !== null &&
                                          item_trecho.fornecedor
                                            .pessoa_juridica !== null
                                        "
                                        >{{
                                          onFormataCnpj(
                                            item_trecho.fornecedor
                                              .pessoa_juridica.cnpj_base,
                                            item_trecho.fornecedor
                                              .pessoa_juridica.cnpj_filial,
                                            item_trecho.fornecedor
                                              .pessoa_juridica.cnpj_digito
                                          )
                                        }}
                                        -
                                        {{
                                          item_trecho.fornecedor.pessoa_juridica
                                            .razao_social
                                        }}</span
                                      >
                                      <span
                                        v-if="
                                          item_trecho.fornecedor !== null &&
                                          item_trecho.fornecedor
                                            .pessoa_fisica !== null
                                        "
                                        >{{
                                          item_trecho.fornecedor.pessoa_fisica
                                            .nome
                                        }}
                                        -
                                        {{
                                          item_trecho.fornecedor.pessoa_fisica
                                            .cpf
                                        }}</span
                                      >
                                      <span
                                        v-if="
                                          item_trecho.fornecedor !== null &&
                                          item_trecho.fornecedor
                                            .pessoa_exterior !== null
                                        "
                                        >{{
                                          item_trecho.fornecedor.pessoa_exterior
                                            .nome
                                        }}
                                        -
                                        {{
                                          item_trecho.fornecedor.pessoa_exterior
                                            .cuit
                                        }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        class="badge badge-success"
                                        v-if="item_trecho.status.valor == 1"
                                        >{{ item_trecho.status.descr }}</span
                                      >
                                      <span
                                        class="badge badge-danger"
                                        v-if="item_trecho.status.valor == 2"
                                        >{{ item_trecho.status.descr }}</span
                                      >
                                    </td>
                                    <td>
                                      <a
                                        @click="
                                          onDetailUnidadeCargaTrechoCusto(
                                            item_trecho.peduncatr_id
                                          )
                                        "
                                        v-if="
                                          item_trecho
                                            .pedido_unidade_carga_tre_custo
                                            .length > 0
                                        "
                                        v-b-tooltip
                                        title="Ver detalhes"
                                        ><i class="fa fa-plus"></i
                                      ></a>
                                    </td>
                                  </tr>
                                  <tr
                                    v-if="
                                      isVisibleDetailRowUCTreCusto(
                                        item_trecho.peduncatr_id
                                      )
                                    "
                                  >
                                    <td colspan="10">
                                      <section class="tabs-section">
                                        <div class="tabs-section-nav">
                                          <div class="tbl">
                                            <ul class="nav" role="tablist">
                                              <li class="nav-item">
                                                <a
                                                  class="nav-link active"
                                                  v-bind:href="
                                                    '#t3' +
                                                    item_trecho.peduncatr_id +
                                                    ''
                                                  "
                                                  role="tab"
                                                  data-toggle="tab"
                                                >
                                                  <span class="nav-link-in">
                                                    Custos
                                                    <i
                                                      class="fa fa-bulding"
                                                    ></i>
                                                  </span>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <!--.tabs-section-nav-->
                                        <div class="tab-content">
                                          <div
                                            role="tabpanel"
                                            class="
                                              tab-pane
                                              fade
                                              in
                                              active
                                              show
                                              pt-1
                                              border-color-detalhes-grey
                                            "
                                            v-bind:id="
                                              't3' +
                                              item_trecho.peduncatr_id +
                                              ''
                                            "
                                          >
                                            <table
                                              :class="[
                                                'vuetable table table-striped tbl-typical',
                                              ]"
                                            >
                                              <thead>
                                                <tr>
                                                  <th style="width: 30%">
                                                    Nº Custo
                                                  </th>
                                                  <th style="width: 30%">
                                                    Descrição
                                                  </th>
                                                  <th style="width: 10%">
                                                    Tipo Custo
                                                  </th>
                                                  <th style="width: 10%">
                                                    Custo
                                                  </th>
                                                  <th style="width: 15%">
                                                    Valor
                                                  </th>
                                                  <th style="width: 5%">
                                                    Status
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody
                                                v-for="item_tre_custo in item_trecho.pedido_unidade_carga_tre_custo"
                                              >
                                                <tr
                                                  class="bg-gray-light"
                                                  style="display: table-row"
                                                >
                                                  <td>
                                                    <span
                                                      v-if="
                                                        item_tre_custo.num_custo !==
                                                        null
                                                      "
                                                      >{{
                                                        item_tre_custo.num_custo
                                                      }}</span
                                                    >
                                                  </td>
                                                  <td>
                                                    <span
                                                      v-if="
                                                        item_tre_custo.descr !==
                                                        null
                                                      "
                                                      >{{
                                                        item_tre_custo.descr
                                                      }}</span
                                                    >
                                                  </td>
                                                  <td>
                                                    <span
                                                      v-if="
                                                        item_tre_custo.tp_custo
                                                          .descr !== null
                                                      "
                                                      >{{
                                                        item_tre_custo.tp_custo
                                                          .descr
                                                      }}</span
                                                    >
                                                  </td>
                                                  <td>
                                                    <span
                                                      v-if="
                                                        item_tre_custo.custo
                                                          .descr !== null
                                                      "
                                                      >{{
                                                        item_tre_custo.custo
                                                          .descr
                                                      }}</span
                                                    >
                                                  </td>
                                                  <td>
                                                    <span
                                                      v-if="
                                                        item_tre_custo.vlr_custo !==
                                                        null
                                                      "
                                                      >{{
                                                        item_tre_custo.vlr_custo
                                                      }}</span
                                                    >
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="
                                                        badge badge-success
                                                      "
                                                      v-if="
                                                        item_tre_custo.status
                                                          .valor == 1
                                                      "
                                                      >{{
                                                        item_tre_custo.status
                                                          .descr
                                                      }}</span
                                                    >
                                                    <span
                                                      class="badge badge-danger"
                                                      v-if="
                                                        item_tre_custo.status
                                                          .valor == 2
                                                      "
                                                      >{{
                                                        item_tre_custo.status
                                                          .descr
                                                      }}</span
                                                    >
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </section>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </section>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t20' + rowData.doc_id + ''"
          v-if="rowData.doc_xml_api.length > 0 || (rowData.doc_log != null && rowData.doc_log.length > 0)"
        >
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_xml_api.length > 0"
          >
            <thead>
              <tr>
                <th data-toggle="true" style="width: 15%">Data Envio</th>
                <th data-toggle="true" style="width: 15%">
                  Data Ultimo Reenvio
                </th>
                <th data-toggle="true" style="width: 5%">Qtde Reenvio</th>
                <th data-toggle="true" style="width: 15%">Versão</th>
                <th data-toggle="true" style="width: 15%">Tipo Integração</th>
                <th data-toggle="true" style="width: 15%">Tipo Envio</th>
                <th data-toggle="true" style="width: 15%">Status</th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_xml_api"
              >
                <td>
                  <span>{{ formatDate(item.dt_inc) }}</span>
                </td>
                <td>
                  <span>{{ formatDate(item.dt_ult_reenvio) }}</span>
                </td>
                <td>
                  <span>{{ item.qtde_reenvio }}</span>
                </td>
                <td>
                  <span>{{ item.versao }}</span>
                </td>
                <td>
                  <span>{{ item.tp_integracao_cte }}</span>
                </td>
                <td>
                  <span>{{ item.tp_envio }}</span>
                </td>
                <td>
                  <span>{{ item.status }}</span>
                </td>
                <td>
                  <a
                    @click="onDownloadXmlApi(item.docxmlapi_id)"
                    v-b-tooltip
                    title="Download XML API"
                    ><i class="fa fa-code"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>

          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_log != null && rowData.doc_log.length > 0"
          >
            <thead>
              <tr>
                <th data-toggle="true" style="width: 15%">
                  Data Primeira Ocorrencia
                </th>
                <th data-toggle="true" style="width: 15%">
                  Data Ultima Ocorrencia
                </th>
                <th data-toggle="true" style="width: 70%">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_log"
              >
                <td>
                  <span>{{ formatDate(item.dt_primeira_ocorrencia) }}</span>
                </td>
                <td>
                  <span>{{ formatDate(item.dt_ultima_ocorrencia) }}</span>
                </td>
                <td>
                  <span>{{ item.descr }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.carga_ocorrencia != null && rowData.carga_ocorrencia.length > 0"
          v-bind:id="'t21' + rowData.doc_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Tipo</th>
                <th style="width: 70%">Ocorrência</th>
                <th style="width: 10%">Data</th>
                <th style="width: 10%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carga_ocorrencia"
              >
                <td>
                  <span
                    v-if="item.docfis_id !== null"
                    class="badge badge-primary"
                    >Documento</span
                  >
                  <span
                    v-if="item.pedunicar_id !== null"
                    class="badge badge-warning"
                    >Unidade Carga</span
                  >
                  <span
                    v-if="item.peduncatr_id !== null"
                    class="badge badge-danger"
                    >Trecho</span
                  >
                </td>
                <td>
                  {{ item.param_ocorrencia.descr }}
                </td>
                <td>
                  {{ formatDate(item.dt_ocorrencia) }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t22' + rowData.doc_id + ''"
          v-if="
            rowData.tp_doc.valor == 2 && rowData.doc_rps.doc_rps_autorizacao
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Código Obra</th>
                <th data-toggle="true" style="width: 10%">Código art</th>
                <th data-toggle="true" style="width: 10%">N° do lote</th>
                <th data-toggle="true" style="width: 10%">N° do protocolo</th>
                <th data-toggle="true" style="width: 10%">Situação do lote</th>
                <th data-toggle="true" style="width: 10%">
                  Código da Mensagem
                </th>
                <th data-toggle="true" style="width: 10%">Mensagem</th>
                <th data-toggle="true" style="width: 10%">
                  Código do cancelamento
                </th>
                <th data-toggle="true" style="width: 10%">TAG</th>
                <th data-toggle="true" style="width: 10%">Quantidade RPS</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.cd_obra }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.cd_art }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.num_lote }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.num_protocolo }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.situacao_lote }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.cd_mensagem_alerta }}
                </td>
                <td>
                  {{
                    rowData.doc_rps.doc_rps_autorizacao.descr_mensagem_alerta
                  }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.cd_cancelamento }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.tag }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_autorizacao.qtde_rps_lote }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t23' + rowData.doc_id + ''"
          v-if="rowData.tp_doc.valor == 2"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Valor da RPS</th>
                <th data-toggle="true" style="width: 10%">Valor do Imposto</th>
                <th data-toggle="true" style="width: 10%">Aliquota ISS</th>
                <th data-toggle="true" style="width: 10%">CFOP</th>
                <th data-toggle="true" style="width: 10%">CNAE</th>
                <th data-toggle="true" style="width: 10%">Código tributação</th>
                <th data-toggle="true" style="width: 10%">Obs</th>
                <th data-toggle="true" style="width: 10%">
                  Naturaza da Operação
                </th>
                <th data-toggle="true" style="width: 10%">
                  Tipo do Regime especial tributação
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.vlr_rps }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.vlr_imposto }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.aliquota_iss }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.cfop_id }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.cnae_id }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.cd_tributacao }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.obs }}
                </td>
                <td>
                  {{ rowData.doc_rps.doc_rps_imposto.natureza_operacao }}
                </td>
                <td>
                  {{
                    rowData.doc_rps.doc_rps_imposto
                      .tp_regime_especial_tributacao
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t24' + rowData.doc_id + ''"
          v-if="rowData.tp_doc.valor == 2"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">
                  Código de verificao
                </th>
                <th data-toggle="true" style="width: 10%">Status do RPS</th>
                <th data-toggle="true" style="width: 10%">Identificação</th>
                <th data-toggle="true" style="width: 10%">Tipo de RPS</th>
                <th data-toggle="true" style="width: 10%">
                  Outras Informações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_rps.cd_verificacao }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="rowData.doc_rps.status_rps.valor == 1"
                    >{{ rowData.doc_rps.status_rps.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="rowData.doc_rps.status_rps.valor == 2"
                    >{{ rowData.doc_rps.status_rps.descr }}</span
                  >
                </td>
                <td>
                  {{ rowData.doc_rps.identificacao.descr }}
                </td>
                <td>
                  {{ rowData.doc_rps.tp_rps.descr }}
                </td>
                <td>
                  {{ rowData.doc_rps.outras_inf }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t25' + rowData.doc_id + ''"
          v-if="rowData.doc_cte && rowData.doc_cte.doc_cte_averbacao.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Número</th>
                <th data-toggle="true" style="width: 10%">Série</th>
                <th data-toggle="true" style="width: 10%">Protocolo</th>
                <th data-toggle="true" style="width: 10%">CNPJ</th>
                <th data-toggle="true" style="width: 10%">Filial</th>
                <th data-toggle="true" style="width: 10%">Tipo doc</th>
                <th data-toggle="true" style="width: 10%">Data averbação</th>
                <th data-toggle="true" style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item_averbacao in rowData.doc_cte.doc_cte_averbacao">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item_averbacao.numero }}
                </td>
                <td>
                  {{ item_averbacao.serie }}
                </td>
                <td>
                  {{ item_averbacao.protocolo }}
                </td>
                <td>
                  {{ item_averbacao.cnpj }}
                </td>
                <td>
                  {{ item_averbacao.filial }}
                </td>
                <td>
                  {{ item_averbacao.tp_doc.descr }}
                </td>
                <td>
                  {{ formatDate(item_averbacao.dh_averbacao) }}
                </td>
                <td>
                  <a
                    @click="onDetailAverbacao(item_averbacao)"
                    v-b-tooltip
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr
                v-if="isVisibleDetailRowAverbacao(item_averbacao.doccteaver_id)"
              >
                <td colspan="9">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="
                            '#t2' + item_averbacao.doccteaver_id + ''
                          "
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Seguro
                            <i class="fa fa-lock"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="
                            '#t1' + item_averbacao.doccteaver_id + ''
                          "
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Info
                            <i class="fa fa-file"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="
                          tab-pane
                          fade
                          in
                          active
                          show
                          pt-1
                          border-color-detalhes-grey
                        "
                        v-bind:id="'t2' + item_averbacao.doccteaver_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 20%">Número averbação</th>
                              <th style="width: 10%">CNPJ seguradora</th>
                              <th style="width: 10%">Nome seguradora</th>
                              <th style="width: 10%">Número apólice</th>
                              <th style="width: 10%">Tipo movimento</th>
                              <th style="width: 10%">Tipo DDR</th>
                              <th style="width: 10%">Valor averbado</th>
                              <th style="width: 10%">Ramo averbado</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item in item_averbacao.doc_cte_averbacao_seguro"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.numero_averbacao }}
                              </td>
                              <td>
                                {{ item.cnpj_seguradora }}
                              </td>
                              <td>
                                {{ item.nome_seguradora }}
                              </td>
                              <td>
                                {{ item.num_apolice }}
                              </td>
                              <td>
                                <span v-if="item.tp_mov != null">{{
                                  item.tp_mov.descr
                                }}</span>
                              </td>
                              <td>
                                <span v-if="item.tp_ddr != null">{{
                                  item.tp_ddr.descr
                                }}</span>
                              </td>
                              <td>
                                {{ item.nome_seguradora }}
                              </td>
                              <td>
                                {{ formatNumber(item.valor_averbado) }}
                              </td>
                              <td>
                                <span v-if="item.ramo_averbado != null">{{
                                  item.ramo_averbado.descr
                                }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'t1' + item_averbacao.doccteaver_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 20%">Código</th>
                              <th style="width: 20%">Descrição</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item_info in item_averbacao.doc_cte_averbacao_info"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item_info.cd }}
                              </td>
                              <td>
                                {{ item_info.descr }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t26' + rowData.doc_id + ''"
          v-if="rowData.doc_rps && rowData.doc_rps.doc_rps_averbacao.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Número</th>
                <th data-toggle="true" style="width: 10%">Série</th>
                <th data-toggle="true" style="width: 10%">Protocolo</th>
                <th data-toggle="true" style="width: 10%">CNPJ</th>
                <th data-toggle="true" style="width: 10%">Filial</th>
                <th data-toggle="true" style="width: 10%">Tipo doc</th>
                <th data-toggle="true" style="width: 10%">Data averbação</th>
                <th data-toggle="true" style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item_averbacao in rowData.doc_rps.doc_rps_averbacao">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item_averbacao.numero }}
                </td>
                <td>
                  {{ item_averbacao.serie }}
                </td>
                <td>
                  {{ item_averbacao.protocolo }}
                </td>
                <td>
                  {{ item_averbacao.cnpj }}
                </td>
                <td>
                  {{ item_averbacao.filial }}
                </td>
                <td>
                  {{ item_averbacao.tp_doc.descr }}
                </td>
                <td>
                  {{ formatDate(item_averbacao.dh_averbacao) }}
                </td>
                <td>
                  <a
                    @click="onDetailAverbacaoRps(item_averbacao)"
                    v-b-tooltip
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr
                v-if="isVisibleDetailRowAverbacao(item_averbacao.docrpsaver_id)"
              >
                <td colspan="9">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="
                            '#t2' + item_averbacao.docrpsaver_id + ''
                          "
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Seguro
                            <i class="fa fa-lock"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="
                            '#t1' + item_averbacao.docrpsaver_id + ''
                          "
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Info
                            <i class="fa fa-file"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="
                          tab-pane
                          fade
                          in
                          active
                          show
                          pt-1
                          border-color-detalhes-grey
                        "
                        v-bind:id="'t2' + item_averbacao.docrpsaver_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 20%">Número averbação</th>
                              <th style="width: 10%">CNPJ seguradora</th>
                              <th style="width: 10%">Nome seguradora</th>
                              <th style="width: 10%">Número apólice</th>
                              <th style="width: 10%">Tipo movimento</th>
                              <th style="width: 10%">Tipo DDR</th>
                              <th style="width: 10%">Valor averbado</th>
                              <th style="width: 10%">Ramo averbado</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item in item_averbacao.doc_rps_averbacao_seguro"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.numero_averbacao }}
                              </td>
                              <td>
                                {{ item.cnpj_seguradora }}
                              </td>
                              <td>
                                {{ item.nome_seguradora }}
                              </td>
                              <td>
                                {{ item.num_apolice }}
                              </td>
                              <td>
                                <span v-if="item.tp_mov != null">{{
                                  item.tp_mov.descr
                                }}</span>
                              </td>
                              <td>
                                <span v-if="item.tp_ddr != null">{{
                                  item.tp_ddr.descr
                                }}</span>
                              </td>
                              <td>
                                {{ item.nome_seguradora }}
                              </td>
                              <td>
                                {{ formatNumber(item.valor_averbado) }}
                              </td>
                              <td>
                                <span v-if="item.ramo_averbado != null">{{
                                  item.ramo_averbado.descr
                                }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'t1' + item_averbacao.docrpsaver_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 20%">Código</th>
                              <th style="width: 20%">Descrição</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item_info in item_averbacao.doc_rps_averbacao_info"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item_info.cd }}
                              </td>
                              <td>
                                {{ item_info.descr }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t27' + rowData.doc_id + ''"
          v-if="
            rowData.doc_rps != null && rowData.doc_rps.doc_carga_doc.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 5%">Tipo</th>
                <th data-toggle="true" style="width: 20%">Chave</th>
                <th data-toggle="true" style="width: 10%">Número Fiscal</th>
                <th data-toggle="true" style="width: 10%">Série</th>
                <th data-toggle="true" style="width: 10%">Data de Emissão</th>
                <th data-toggle="true" style="width: 10%">CNPJ</th>
                <th data-toggle="true" style="width: 20%">Razão Social</th>
                <th data-toggle="true" style="width: 10%">
                  Inscrição Estadual
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_rps.doc_carga_doc"
              >
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ item.carga_doc.doc_fiscal.liv_tp_doc.descr }}
                  </span>
                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{ item.carga_doc.doc_transp.liv_tp_doc.descr }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    <span v-if="item.carga_doc.doc_fiscal.chave">
                      {{ item.carga_doc.doc_fiscal.chave }}
                    </span>
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    <span v-if="item.carga_doc.doc_transp.chave">
                      {{ item.carga_doc.doc_transp.chave }}
                    </span>
                  </span> -->
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="item.carga_doc.doc_fiscal"
                  >
                    {{ item.carga_doc.doc_fiscal.num_fiscal }}
                  </span>

                  <!-- <span
                    class="badge badge-danger"
                    v-if="item.carga_doc.doc_transp !== null"
                  >
                    {{ item.carga_doc.doc_transp.num_doc }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ item.carga_doc.doc_fiscal.serie }}
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{ item.carga_doc.doc_transp.serie }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{ formatDate(item.carga_doc.doc_fiscal.dt_emissao) }}
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{ formatDate(item.carga_doc.doc_transp.dt_emissao) }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_cnpj
                    }}
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_cnpj
                    }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_nome
                    }}
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_nome
                    }}
                  </span> -->
                </td>
                <td>
                  <span v-if="item.carga_doc.doc_fiscal">
                    {{
                      item.carga_doc.doc_fiscal.doc_fiscal_partes_env.emi_cnpj
                    }}
                  </span>

                  <!-- <span v-if="item.carga_doc.doc_transp !== null">
                    {{
                      item.carga_doc.doc_transp.doc_transp_partes_env.emi_cnpj
                    }}
                  </span> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import accounting from "accounting";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      isIbsCbsTaxActive: true,
      visibleDetailRows: [],
      visibleDetailRowsPedido: [],
      visibleDetailRowsAverbacao: [],
      visibleDetailRowsUCTreCusto: [],
      helpForm: new Form({ statusRecord: [], params: [] }),
      formimprimir: new Form({
        docxmlapi_id: "",
      }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onPrintCarta(carcor_id) {
      this.$parent.$parent.onPrintCarta(carcor_id);
    },
    onAlterarCdErp(doctpaen_id, tipo_erp) {
      Event.$emit("alterarcderp", doctpaen_id, tipo_erp);
    },
    onCreateEnviarXmlDacte(doccte_id) {
      Event.$emit("enviarxmldacte", doccte_id);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    isVisibleDetailRowPedido(rowId) {
      return this.visibleDetailRowsPedido.indexOf(rowId) >= 0;
    },
    showDetailRowPedido(rowId) {
      if (!this.isVisibleDetailRowPedido(rowId)) {
        this.visibleDetailRowsPedido.push(rowId);
      }
    },
    hideDetailRowPedido(rowId) {
      if (this.isVisibleDetailRowPedido(rowId)) {
        this.visibleDetailRowsPedido.splice(
          this.visibleDetailRowsPedido.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowPedido(rowId) {
      if (this.isVisibleDetailRowPedido(rowId)) {
        this.hideDetailRowPedido(rowId);
      } else {
        this.showDetailRowPedido(rowId);
      }
    },
    ////////////////////////////////////////////////
    isVisibleDetailRowAverbacao(rowId) {
      return this.visibleDetailRowsAverbacao.indexOf(rowId) >= 0;
    },
    showDetailRowAverbacao(rowId) {
      if (!this.isVisibleDetailRowAverbacao(rowId)) {
        this.visibleDetailRowsAverbacao.push(rowId);
      }
    },
    hideDetailRowAverbacao(rowId) {
      if (this.isVisibleDetailRowAverbacao(rowId)) {
        this.visibleDetailRowsAverbacao.splice(
          this.visibleDetailRowsAverbacao.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowAverbacao(rowId) {
      if (this.isVisibleDetailRowAverbacao(rowId)) {
        this.hideDetailRowAverbacao(rowId);
      } else {
        this.showDetailRowAverbacao(rowId);
      }
    },
    ////////////////////////////////////////////////
    isVisibleDetailRowUCTreCusto(rowId) {
      return this.visibleDetailRowsUCTreCusto.indexOf(rowId) >= 0;
    },
    showDetailRowUCTreCusto(rowId) {
      if (!this.isVisibleDetailRowUCTreCusto(rowId)) {
        this.visibleDetailRowsUCTreCusto.push(rowId);
      }
    },
    hideDetailRowUCTreCusto(rowId) {
      if (this.isVisibleDetailRowUCTreCusto(rowId)) {
        this.visibleDetailRowsUCTreCusto.splice(
          this.visibleDetailRowsUCTreCusto.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowUCTreCusto(rowId) {
      if (this.isVisibleDetailRowUCTreCusto(rowId)) {
        this.hideDetailRowUCTreCusto(rowId);
      } else {
        this.showDetailRowUCTreCusto(rowId);
      }
    },
    onDetailTrecho(data) {
      this.toggleDetailRow(data.pedpartrc_id);
    },
    onDetailAverbacao(data) {
      this.toggleDetailRowAverbacao(data.doccteaver_id);
    },
    onDetailAverbacaoRps(data) {
      this.toggleDetailRowAverbacao(data.docrpsaver_id);
    },
    onDetailUnidadeCargaTrecho(pedunicar_id) {
      this.toggleDetailRowPedido(pedunicar_id);
    },
    onDetailUnidadeCargaTrechoCusto(peduncatr_id) {
      this.toggleDetailRowUCTreCusto(peduncatr_id);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onDownloadXmlApi(docxmlapi_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.docxmlapi_id = docxmlapi_id;
      this.formimprimir
        .post("/api/cte/downloadxmlapi")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
  },
  computed: {
    casasDecimais: {
      get() {
        return this.$store.getters.casas_decimais;
      },
    },
  },
};
</script>